var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#DB5461"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 16.25C8.75 15.5597 9.30967 15 10 15H10.0083C10.6987 15 11.2583 15.5597 11.2583 16.25V16.2583C11.2583 16.9487 10.6987 17.5083 10.0083 17.5083H10C9.30967 17.5083 8.75 16.9487 8.75 16.2583V16.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 13.3334C9.5555 13.3334 9.18875 12.9829 9.16858 12.5379L8.77083 3.78747C8.73891 3.08611 9.29891 2.50006 10.001 2.50006C10.7031 2.50006 11.2631 3.08611 11.2312 3.78747L10.8335 12.5379C10.8132 12.9829 10.4466 13.3334 10.001 13.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.a62142b354b51c9deb9ff0d3eb9f821d.svg";
export { ForwardRef as ReactComponent };